// extracted by css-extract-rspack-plugin
export default {"root":"a6BR4u"};